var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHistoryLeave = function SvgHistoryLeave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.85,
    d: "M11.464 6v1.319h-6.04a.143.143 0 0 0-.143.143v1.071c0 .079.064.143.143.143h6.04v1.323c0 .12.138.186.23.113l2.532-2a.143.143 0 0 0 0-.225l-2.53-2a.144.144 0 0 0-.232.112M5.96 14.533v-1.07a.143.143 0 0 0-.143-.144h-2.75V2.678h2.75a.143.143 0 0 0 .143-.143v-1.07a.143.143 0 0 0-.143-.144H2.281a.57.57 0 0 0-.571.572v12.213a.57.57 0 0 0 .571.571h3.535a.143.143 0 0 0 .143-.143"
  })));
};
export default SvgHistoryLeave;